import { render, staticRenderFns } from "./EasyProcess.vue?vue&type=template&id=64394bd5&scoped=true"
import script from "./EasyProcess.vue?vue&type=script&lang=js"
export * from "./EasyProcess.vue?vue&type=script&lang=js"
import style0 from "./EasyProcess.vue?vue&type=style&index=0&id=64394bd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64394bd5",
  null
  
)

export default component.exports